import React, { Component } from 'react'


import './Error.css'

class Error extends Component {


    render() {

        return (

            <div className="error text-center">

                <hr />

                <h1 className="mb5">
                    Yikes
                </h1>

                <p>There was an error getting this data from <a href="contentful.com" className="line">contentful</a>.</p>

                <hr />
                
            </div>


        );
    }
}


export default Error;